<template>
  <div class="creditedDetails">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList()"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
        @click="gotoDetail(item)"
      >
        <div class="list-item" v-if="item.InvoiceNo">
          {{ $t.creditedDetails.invoiceNo }}：{{ item.InvoiceNo }}
        </div>
        <div class="list-item" v-if="item.FinancialAccountNo">
          {{ $t.creditedDetails.financialAccountNo }}：{{ item.FinancialAccountNo }}
        </div>
        <div class="list-item">
          {{ $t.creditedDetails.mainWbNumber }}：{{ item.PWB_Number }}
        </div>
        <div class="list-item">
          {{ $t.creditedDetails.sideWbNumber }}：{{ item.WB_Number }}
        </div>
        <div class="list-item">
          {{ $t.creditedDetails.warehouseWorkNumber }}：{{ item.WarehouseWorkNumber }}
        </div>
        <div class="list-item">
          {{ $t.creditedDetails.workOrderNumber }}：{{ item.WorkOrderNumber }}
        </div>
        <div class="list-item">
          {{ $t.creditedDetails.customerName }}：{{ item.CompanyNameSn }}
        </div>
        <div class="list-item">
          {{ $t.creditedDetails.createDate }}：{{ item.InvoiceDate }}
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { List, Row, Col, Button, Form, Field } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button).use(Form).use(Field);

export default {
  name: "creditedDetails",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      nuclearAccountNo: "",
    };
  },
  created() {
    const { NuclearAccountNo } = this.$route.query;
    this.nuclearAccountNo = NuclearAccountNo;
  },
  methods: {
    gotoDetail(item) {
      var data = item;
      localStorage.setItem("creditedDetailsInfo", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "creditedDetailsInfo",
        name: "creditedDetailsInfo",
        query: [],
      });
    },
    getList() {
      var param = {
        NuclearAccountNo: this.nuclearAccountNo,
      };
      this.$api.financialManagement
        .getCreditedDetailList(param)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.creditedDetails {
  .list {
    width: 100%;
    display: inline-block;
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
